export const affiliateIds = {
  MYJD: 'myjd'
};
export const mycroftAffiliateIds = {
  'myjd': 'deere'
}; // SIGHHHHHHH
export const workPlanStates = {
  COMPLETE: 'COMPLETE'
};
